
import { convertToSlug } from '~/helpers/generate-slug'
export default {
  props: {
    item: {
      default: () => {},
    },
  },
  methods: {
    convertToSlug,
  },
}
